<div
  *ngFor="let product of searchProduct"
  class="border-primary-md-light-dark fc-animate-translate-up relative flex w-full cursor-pointer items-start border-b p-3 hover:bg-gray-100"
  (click)="navigateToProduct(product)">
  <div class="relative h-10 w-10">
    <img
      class="h-10 w-10"
      [src]="product.image_path.small"
      [alt]="product.name" />
  </div>
  <div class="flex-1 px-3 pb-0">
    <div>
      <div class="text-xs font-semibold uppercase text-primary-md-dark">
        {{ product.brand_name }}
      </div>
      <div class="text-sm font-bold text-primary-darkest">
        {{ product.name }}
      </div>
      <div class="flex justify-between text-xs">
        <div class="self-end" *ngIf="product.has_variant">
          <div
            class="text-xs text-gray-600 line-through"
            *ngIf="
              product.max_price != product.actual_max_price ||
              product.min_price != product.actual_min_price
            ">
            {{ product.actual_min_price | fcCurrency }} -
            {{ product.actual_max_price | fcCurrency }}
          </div>
          <div class="font-semibold text-secondary-main">
            {{ product.min_price | fcCurrency }} -
            {{ product.max_price | fcCurrency }}
          </div>
        </div>
        <div class="self-end" *ngIf="!product.has_variant">
          <div
            class="text-xs text-gray-600 line-through"
            *ngIf="
              product.max_price != product.actual_max_price ||
              product.min_price != product.actual_min_price
            ">
            {{ product.actual_max_price | fcCurrency }}
          </div>
          <div class="font-semibold text-secondary-main">
            {{ product.max_price | fcCurrency }}
          </div>
        </div>
        <div
          class="flex items-center self-end text-right"
          *ngIf="product.average_rating != 0">
          <fa-icon
            class="mr-1 text-xs text-yellow-400"
            [icon]="faStar"></fa-icon>
          <span class="text-sm font-semibold text-primary-darkest">{{
            product.average_rating
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="loading">
  <div class="mt-1 flex-row items-center justify-center gap-2 text-center">
    <i
      class="pi pi-spin pi-spinner text-primary-darkest"
      style="font-size: 1.5rem">
    </i>
    <div class="semibold text-primary-darkest">Looking for the results ...</div>
  </div>
</ng-container>
<ng-container *ngIf="searchProduct.length == 0 && !loading">
  <div class="mt-1 text-center text-primary-darkest">
    <img
      src="assets/images/product/no-result-search-dummy.png"
      class="illust mx-auto w-full max-w-[250px]" />
    <div class="text-lg font-bold">No results found</div>
    <div class="mx-auto">
      We cant find any brand & product matching your search.
    </div>
  </div>
</ng-container>
